"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearMakeModelDto = void 0;
class YearMakeModelDto {
    constructor(params) {
        this.make = "";
        this.model = "";
        this.style = "";
        this.styleId = "";
        this.fullStyleCode = "";
        this.histStyleId = "";
        this.histModelId = "";
        this.autoBuilderStyleId = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.year = params.year;
        this.make = params.make;
        this.model = params.model;
        this.style = params.style;
        this.styleId = params.styleId;
        this.fullStyleCode = params.fullStyleCode;
        this.histStyleId = params.histStyleId;
        this.histModelId = params.histModelId;
        this.autoBuilderStyleId = params.autoBuilderStyleId;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
    }
}
exports.YearMakeModelDto = YearMakeModelDto;
//# sourceMappingURL=YearMakeModelDto.js.map